var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTemperature = function SvgTemperature(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 84 84"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#temperature_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    x: 16,
    y: 12,
    fill: "#fff",
    rx: 8,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1F4970",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    strokeWidth: 1.5,
    d: "M48.851 31.52v11.95a1.8 1.8 0 0 0 .613 1.355 6.2 6.2 0 0 1 2.125 4.694c0 3.439-2.76 6.231-6.16 6.231s-6.161-2.792-6.161-6.23c0-1.876.82-3.56 2.118-4.702.388-.338.61-.83.61-1.347.01-3.206.01-14.486.01-20.26 0-.917.36-1.798 1.002-2.447a3.4 3.4 0 0 1 2.42-1.014c1.89 0 3.423 1.55 3.423 3.462v5.538"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1F4970",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    strokeWidth: 1.5,
    d: "M48.851 49.865c0 1.911-1.533 3.462-3.422 3.462s-3.423-1.55-3.423-3.462c0-1.09.499-2.062 1.278-2.697.483-.4.763-.998.762-1.629.013-2.228.013-8.504.013-10.904 0-.765.613-1.385 1.37-1.385.756 0 1.369.62 1.369 1.385v10.904c0 .635.282 1.237.767 1.639M46.455 31.52h2.396M46.455 28.75h2.396M46.455 25.98h2.396M54.328 37.058c.756 0 1.37-.62 1.37-1.385s-.614-1.385-1.37-1.385-1.369.62-1.369 1.385.613 1.385 1.369 1.385M35.161 27.365c1.134 0 2.054-.93 2.054-2.076 0-1.148-.92-2.078-2.054-2.078s-2.054.93-2.054 2.078c0 1.146.92 2.076 2.054 2.076M36.53 48.178a6.24 6.24 0 0 1-3.423-5.582c0-3.439 2.761-6.23 6.161-6.23.983 0 1.913.233 2.738.648M39.268 34.289V32.21M33.46 48.47l-1.453 1.47M29 42.596h2.054M32.007 35.253l1.452 1.469"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "temperature_svg__a",
    width: 84,
    height: 84,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.745833 0 0 0 0 0.745833 0 0 0 0 0.745833 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2710_35603"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2710_35603",
    result: "shape"
  })))));
};
export default SvgTemperature;